module.exports = {
  home: 'Home',
  about: 'Over ons',
  aboutUs: 'Over ons',
  portfolio: 'Portfolio',
  team: 'Team',
  news: 'Nieuws',
  contact: 'Contact',
  csr: 'CSR',
  esg: 'ESG',
  jobs: 'Vacatures',
  investorLogIn: 'Investeerder inloggen',
  ourApproach: 'Onze aanpak',
  careers: 'Vacatures',
  corpResponsibility: 'Stichting Timbo Afrika',
  returns: 'Rendement',
  investmentFocus: 'Investeringsfocus',
  linkedinConnect: 'Bekijk ons op LinkedIn',
  activeApproach: 'De Active aanpak',
  menu: 'Menu',
  openPositions: 'Open posities',
  allRightsReserved: 'Alle rechten voorbehouden',
  madeBy: 'Ontwikkeld door',
  by: 'van',
  howWeWork: 'Hoe wij werken',
  theACCway: 'De ACC manier',
};
